// ----------------------------------------------------------------------

const account = {
  displayName: 'CodeXFlow',
  email: 'codexflow.co',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
